export const defaultRules = [
  {
    name: "landingPage",
    order: 1,
    value:
      "The selected service is not available for online scheduling. Please call our office to schedule your appointment",
    message: "Message for call-to-schedule services",
  },
  {
    name: "landingPage",
    order: 2,
    value: "No",
    message: "Allow patients to schedule multiple appointments?",
  },
  {
    name: "landingPage",
    order: 3,
    value:
      "It looks like you already have an appointment scheduled for APPTDATE at APPTTIME. If you need to make a change to that appointment, please call our office.",
    message: "Message for patients who already have an appointment",
  },
  {
    name: "appointment",
    order: 1,
    value: 10,
    message: "How far out can online appointments be scheduled for?",
  },
  {
    name: "appointment",
    order: 2,
    value: "BusinessDays",
    message: "Days Type",
  },
  {
    name: "appointment",
    order: 3,
    value: "No",
    message: "Allow provider changes for existing patients?",
  },
  {
    name: "appointment",
    order: 4,
    value: "alphabetic",
    message: "How to sort providers",
  },
  {
    name: "appointment",
    order: 5,
    value: "No",
    message: "Show providers with no capacity",
  },
  {
    name: "appointment",
    order: 6,
    value:
      "This provider has no online availability. Please call our office to schedule with them.",
    message: "Message for no-capacity providers",
  },
  {
    name: "appointment",
    order: 7,
    value: "No",
    message: "Offer waitlist for no-capacity providers",
  },
  {
    name: "appointment",
    order: 8,
    value:
      "This provider cannot be booked online. Please call our office to schedule with them.",
    message: "Message for provider that can't be booked online",
  },
  {
    name: "appointment",
    order: 9,
    value:
      "This location has no online availability. Please call our office to schedule.",
    message: "Message for no-capacity locations",
  },
  {
    name: "appointment",
    order: 10,
    value: "No",
    message: "Offer waitlist for no-capacity locations",
  },
  {
    name: "appointment",
    order: 11,
    value:
      "This service cannot be booked online. Please call our office to schedule.",
    message: "Message for service that can’t be booked online",
  },
  {
    name: "appointment",
    order: 12,
    value:
      "The selected location is not available for online scheduling. Please call our office to schedule your appointment.",
    message: "Message for online-off locations",
  },
  {
    name: "appointment",
    order: 13,
    value: "Yes",
    message: "Allow existing patients to schedule?",
  },
  {
    name: "appointment",
    order: 14,
    value:
      "Existing patients are not able to schedule online at this time. Please call our office to schedule your appointment.",
    message: "Message for existing patients",
  },
  {
    name: "appointment",
    order: 15,
    value: 2,
    message: "How soon can online appointments be scheduled for?",
  },
  {
    name: "appointment",
    order: 16,
    value: "BusinessDays",
    message: "Start days Type?",
  },
  {
    name: "appointment",
    order: 17,
    value: "Yes",
    message: "Group appointment slots by provider?",
  },
  {
    name: "appointment",
    order: 18,
    value: "random",
    message: "How to assign appointment when multiple providers are available",
  },
  {
    name: "appointment",
    order: 19,
    value:
      "The appointment slot you have selected is no longer available. Please call our office PHONENUMBER or click the button below to select a new appointment time",
    message: "Message for unavailable slots: ",
  },
  {
    name: "appointment",
    order: 20,
    value: "#024E94",
    message: "Widget Color",
  },
  {
    name: "insurance",
    order: 1,
    value: "No",
    message: "Check insurance compatibility before booking",
  },
  {
    name: "insurance",
    order: 2,
    value:
      "Selected insurance plan is not in-network with the provider. Please call our office to book your appointment.",
    message: "Message for insurance plan not accepted by provider",
  },
  {
    name: "insurance",
    order: 3,
    value: "No",
    message: "Self-pay check (if insurance is 'No')",
  },
  {
    name: "thankYouScreen",
    order: 1,
    value:
      "Your appointment has been scheduled! If you need to reschedule, please contact us at least 48 hours in advance.",
    message: "Primary thank you message",
  },
  {
    name: "thankYouScreen",
    order: 2,
    value: "Call our office if you have any questions.",
    message: "Secondary thank you message",
  },
];
